import ClearCache from './types';

const clearStorage: ClearCache = () => new Promise<void>((res) => res());

export default clearStorage;
